import React from 'react';
import { EhrIntegrationSettingsData } from '@/common/types';

interface EhrSettingsViewProps {
  data: EhrIntegrationSettingsData;
}

const EhrSettingsView: React.FC<EhrSettingsViewProps> = ({ data }) => {
  return (
    <div>
      <div className="mb-3">
        <strong>EHR Provider:</strong>
        <div className="text-muted">{data.ehrProvider}</div>
      </div>
      <div className="mb-3">
        <strong>Patient Login URL:</strong>
        <div className="text-muted">
          <a
            href={data.patientLoginUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.patientLoginUrl}
          </a>
        </div>
      </div>
      <div className="mb-3">
        <strong>Provider Appointment Base URL:</strong>
        <div className="text-muted">
          <a
            href={data.providerAppointmentBaseUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.providerAppointmentBaseUrl}
          </a>
        </div>
      </div>
    </div>
  );
};

export default EhrSettingsView;
